import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import { withRouter } from 'react-router-dom'
import couterpart from 'counterpart';
// import ReactTablePagination from './PaginationComponent';
import {ToastsContainer, ToastsStore} from 'react-toasts';

import {MdDeleteForever, MdModeEdit} from 'react-icons/md';
import MasterDataService from '../services/MasterDataService';

import WorkOrderDataService from '../services/WorkOrderDataService';
import AuthenticationService from '../services/AuthenticationService';
import WorkOrderUtil from '../utilities/WorkOrderUtil';

import {ICON_COLOR} from '../icon';

import { SELECTED_WORKORDER_IDX } from '../constants';

class ProductListView extends Component {
  constructor () {
    super();
   
    this.state = {
      orderId: null,
      selected: this.getSelectedOrderIdx(),
      allStatus: [],
      columns : [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row =>(
            <div style={{ padding: "10px"}}>{row.index + 1}</div>
          )
        },        
        {
          id: "checkbox",
          accessor: "",
          Cell: ({ original }) => {
            return (
              <div style={{ textAlign: "center" }}>
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selected[original.id] === true}
                onChange={() => this.toggleRow(original.id)}
              /></div>
            );
          },
          Header: x => {
            return (
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selectAll === 1}
                ref={input => {
                  if (input) {
                    input.indeterminate = this.state.selectAll === 2;
                  }
                }}
                onChange={() => this.toggleSelectAll()}
              />
            );
          },
          sortable: false,
          width: 45
        },
        {
          Header: couterpart.translate('work_order_no'),
          accessor: 'workOrderNo',
          width: 150
        },{
          Header: couterpart.translate('work_order_name'),
          accessor: 'name',
          filterable: false,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        },{
          Header: couterpart.translate('work_order_store'),
          accessor: 'store',
          filterable: false,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        },{
          Header: couterpart.translate('work_order_exported'),
          accessor: 'exportedAtTs',
          filterable: false
        },{          
          Header: couterpart.translate('work_order_status'),
          accessor: 'status',
          width: 150,
          Cell: props => this.getStatusDescription(props.value)
        },{          
          Header: couterpart.translate('ship_to'),
          accessor: 'shipTo',
          width: 90
        },{
          Header: couterpart.translate('imageURL'),
          accessor: 'imageURL',
          filterable: false                         
        },{
          Header: couterpart.translate('last_change_note'),
          accessor: 'changedNote',
          width: 200,
          Cell: props =>(
            <pre className="note-details">{ props.value }</pre>
          )                         
        },{                     
          Header: couterpart.translate('work_order_action'),
          accessor: 'action',
          width: 200,
          Cell: row =>(
            <div style={{ textAlign: "center" }}>
                {this.renderEditButton(row)}
            </div>
          )
      }]
    };
  }

  getSelectedOrderIdx(){
    var selected = sessionStorage.getItem(`${SELECTED_WORKORDER_IDX}`);
    if((selected === undefined) || (selected === null)){
      selected = "-1";
    }
    return parseInt(selected, 10);
  }

  toggleRow(id) {
		const newSelected = Object.assign({}, this.state.selected);
		newSelected[id] = !this.state.selected[id];
		this.setState({
			selected: newSelected,
			selectAll: 2
		}, () =>{
      sessionStorage.setItem(`${SELECTED_WORKORDER_IDX}`, this.state.selected);
      this.props.parentCallback(this.state.selected);
    });
	}

	toggleSelectAll() {
		let newSelected = {};

		if (this.state.selectAll === 0) {
			this.props.workOrders.forEach(x => {
				newSelected[x.id] = true;
			});
		}

		this.setState({
			selected: newSelected,
			selectAll: this.state.selectAll === 0 ? 1 : 0
		}, () =>{
      sessionStorage.setItem(`${SELECTED_WORKORDER_IDX}`, this.state.selected);
      this.props.parentCallback(this.state.selected);
    });
	}

  getStatusDescription(status){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return status;
    }    
    let istatus = parseInt(status);
    let statusInfo = this.state.allStatus.find(x =>{
      return x.status === istatus;
    });
    if (statusInfo !== undefined){
      return statusInfo.statusDescVn;
    }   
    return status;     
  }

  renderEditButton(row){
    const button_edit = couterpart.translate('button_edit');
    const button_review = couterpart.translate('button_review');

    if (AuthenticationService.isAdmin() || AuthenticationService.isService()){
      return (<div>
              <button className="myButton" onClick={() => this.handleEdit(row)}>
                <MdModeEdit color={ICON_COLOR}/>
                &nbsp;{button_edit}</button>
                &nbsp;
              <button className="myButton" onClick={() => this.handleSetReviewed(row)}>
              <MdDeleteForever color={ICON_COLOR}/>
              &nbsp;{button_review}</button>
                </div>
              );
    }else{
      return (<></>);
    }
  }

  // static getDerivedStateFromProps(nextProps, state){
  //   // console.log('nextProps.refreshCount', nextProps.refreshCount, state.childRefreshCount)
  //   // if (nextProps.refreshCount !== state.childRefreshCount) {
  //   //   return { childRefreshCount: nextProps.refreshCount, selected: []}
  //   // }
  // }

  componentDidMount () {
    let tmp = WorkOrderUtil.getItem('changedProducts.selectedPage');
    let iSelectPage = 0;
    if (tmp !== undefined) {
      iSelectPage = parseInt(tmp);
    }

    MasterDataService.retrieveAllStatus().then(data => {
      this.setState({ allStatus:  data}, () => {
        let tmp = WorkOrderUtil.getItem('changedProducts.selectedRow')
        let selected = tmp ? parseInt(tmp) : 0;
        this.setState({selectedRow: selected, selectedPage: iSelectPage })
      }) 
    });
  }

  handleEdit(e){
    this.setState({
      selectedRow: e.viewIndex,
      workOrderId: e.original.id
    }, () => {
      WorkOrderUtil.saveItem('changedProducts.selectedRow', e.viewIndex);   
      if (AuthenticationService.isAdmin()){
        this.props.history.push("/workOrders/edit/" + e.original.id + "?back=changedWo");
        return;
      }

      if (AuthenticationService.isService()){
        this.props.history.push("/workOrders/service/" + e.original.id + "?back=changedWo");
      }
    })
  }

  handleSetReviewed(e){
    WorkOrderDataService.completeChangedWorkOrders(e.original.id).then(data => {
      if (data.message === undefined){
        this.props.reloadCallback();
      }
    });
  }

  render() {
    return (
          <div>
              <hr/>
              <ToastsContainer store={ToastsStore} position="bottom_center" />
              <ReactTable
                NoDataComponent={() => null} 
                // PaginationComponent={ReactTablePagination}
                previousText={"<"}
                nextText={">"}              
                data={this.props.workOrders}
                page={ this.state.selectedPage }
                onPageChange={(pageIndex) => {
                  this.setState({ selectedPage: pageIndex})
                  WorkOrderUtil.saveItem('changedProducts.selectedPage', pageIndex)
                }} 
                columns={this.state.columns}
                defaultPageSize = {10}
                showPageSizeOptions = {true}
                pageSizeOptions = {[3, 5, 10, 20]}
                getTrProps={(state, rowInfo, column) => { 
                  if (rowInfo && rowInfo.row) {
                    return {
                      onClick: (e) => {
                        this.setState({
                          selectedRow: rowInfo.index,
                          workOrderId: rowInfo.original.id
                        }, () => {
                          WorkOrderUtil.saveItem('changedProducts.selectedRow', this.state.selectedRow);
                        })
                      },
                      style: {
                        background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                        color: rowInfo.index === this.state.selectedRow ? 'white' : 'black'
                      }
                    }
                  }else{
                    return {}
                  }
                }
              }
              />
          </div>      
    )
  }
}

export default withRouter(ProductListView);